module.exports = __webpack_public_path__ + "images/ajax-loader2.gif";